import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import { encryptTransform } from "redux-persist-transform-encrypt";

import login from './login';
import user from './user';
import numbers from './numbers';
import constant from './constant';
import portin from './portin';
import payment from './paymentservice';
import adminOnboarding from './adminOnboarding';
import userOnboarding from './userOnboarding';
import huntgroup from './huntgroup';
import auto from './auto';
import devices from './devices';
import policy from './policy';
import profile from './profile';
import callqueue from './callqueue';
import conferencebridge from './conferencebridge';
import siptrunk from './siptrunk';

const reducers = combineReducers({
  login: login,
  user: user,
  numbers: numbers,
  constant: constant,
  portin: portin,
  payment: payment,
  adminOnboarding: adminOnboarding,
  userOnboarding: userOnboarding,
  huntgroup: huntgroup,
  auto: auto,
  devices: devices,
  policy: policy,
  profile: profile,
  callqueue: callqueue,
  conferencebridge: conferencebridge,
  siptrunk: siptrunk,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ["login", "numbers", "constant", "payment", "user", "huntgroup", "devices", "policy", "auto", "profile", "portin", "callqueue", "conferencebridge", "siptrunk"],
  transforms: [
    encryptTransform({
      secretKey: "my-super-secret-key",
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

export { store };